module.exports = __webpack_public_path__ + "img/ic_cross.f79ee3c3.svg";